import Electroducts from "../classes/Electroduct"

export const electroducts = [
  new Electroducts({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new Electroducts({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new Electroducts({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
